import { render, staticRenderFns } from "./Senders.vue?vue&type=template&id=3520624d"
import script from "./Senders.vue?vue&type=script&lang=js"
export * from "./Senders.vue?vue&type=script&lang=js"
import style0 from "./Senders.vue?vue&type=style&index=0&id=3520624d&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports